import { TimelineMax, Power2 } from "gsap/all";
window.gsap = require('gsap').gsap;
window.ScrollTrigger = require('gsap/ScrollTrigger').ScrollTrigger;

$(function () {
	var tl = new TimelineMax({repeat:-1});

	$(".gif-inner-image").each(function(index, element){
	  	tl.to(element, 0.5, {zIndex:1, opacity:1})
	    .to(element, 0.5, {zIndex:0, opacity:0, ease:Power2.easeIn}, "+=1")
	});

    gsap.config({ nullTargetWarn: false });
    gsap.registerPlugin(ScrollTrigger);
    gsap.fromTo('#section_1 .project-content-title, #section_1 .project-content-title-2, #section_1 .project-content-paragraph, #section_1 .project-content-list', {
        y: 50, 
        opacity: 0,
    } , 
    {
        y: 0, 
        opacity: 1,
        stagger: 0.1,
        duration: 1,
        scrollTrigger: {
            trigger: '#abbott-social-listening, #abbott-web-ar, #affin-hwang, #clarins, #ellgy-plus-cny, #adqlo, #mah-sing, #rakuten-trade, #pizzahut-th, #moh, #loreal-groupe, #bake-with-yen-tiktok, #bake-with-yen-social-media, #summer-fun, #shiseido-waso, #kose-save-the-blue-campaign, #physiogel, #boh-tea, #nars',
            start: 'top-=150 top+=150',
            end: 'center center',
            //markers: true,
        }
    });
    gsap.fromTo('#section_2 .project-content-title, #section_2 .project-content-title-2, #section_2 .project-content-paragraph, #section_2 .project-content-list', {
        y: 50, 
        opacity: 0,
    } , 
    {
        y: 0, 
        opacity: 1,
        stagger: 0.1,
        duration: 1,
        scrollTrigger: {
            trigger: '#section_1',
            start: 'top-=50 top+=50',
            end: 'center center',
            //markers: true,
        }
    });
    gsap.fromTo('#section_3 .project-content-title, #section_3 .project-content-title-2, #section_3 .project-content-paragraph, #section_3 .project-content-list, #section_3 .bwy-campaign-text', {
        y: 50, 
        opacity: 0,
    } , 
    {
        y: 0, 
        opacity: 1,
        stagger: 0.1,
        duration: 1,
        scrollTrigger: {
            trigger: '#section_2',
            start: 'top-=250 top+=250',
            end: 'center center',
            //markers: true,
        }
    });
    gsap.fromTo('#section_4 .project-content-title, #section_4 .project-content-title-2, #section_4 .project-content-paragraph, #section_4 .project-content-list', {
        y: 50, 
        opacity: 0,
    } , 
    {
        y: 0, 
        opacity: 1,
        stagger: 0.1,
        duration: 1,
        scrollTrigger: {
            trigger: '#section_3',
            start: 'top-=50 top+=50',
            end: 'center center',
            //markers: true,
        }
    });
    gsap.fromTo('#section_5 .project-content-title, #section_5 .project-content-title-2, #section_5 .project-content-paragraph, #section_5 .project-content-list', {
        y: 50, 
        opacity: 0,
    } , 
    {
        y: 0, 
        opacity: 1,
        stagger: 0.1,
        duration: 1,
        scrollTrigger: {
            trigger: '#section_4',
            start: 'top-=50 top+=50',
            end: 'center center',
            //markers: true,
        }
    });
    gsap.fromTo('#section_6 .project-content-title, #section_6 .project-content-title-2, #section_6 .project-content-paragraph, #section_6 .project-content-list, #section_6 .bwy-campaign-text', {
        y: 50, 
        opacity: 0,
    } , 
    {
        y: 0, 
        opacity: 1,
        stagger: 0.1,
        duration: 1,
        scrollTrigger: {
            trigger: '#section_5',
            start: 'top-=50 top+=50',
            end: 'center center',
            //markers: true,
        }
    });
    gsap.fromTo('#section_7 .project-content-title, #section_7 .project-content-title-2, #section_7 .project-content-paragraph, #section_7 .project-content-list', {
        y: 50, 
        opacity: 0,
    } , 
    {
        y: 0, 
        opacity: 1,
        stagger: 0.1,
        duration: 1,
        scrollTrigger: {
            trigger: '#section_6',
            start: 'top-=50 top+=50',
            end: 'center center',
            //markers: true,
        }
    });
    gsap.fromTo('#section_8 .project-content-title, #section_8 .project-content-title-2, #section_8 .project-content-paragraph, #section_8 .project-content-list', {
        y: 50, 
        opacity: 0,
    } , 
    {
        y: 0, 
        opacity: 1,
        stagger: 0.1,
        duration: 1,
        scrollTrigger: {
            trigger: '#section_7',
            start: 'top-=50 top+=50',
            end: 'center center',
            //markers: true,
        }
    });
    gsap.fromTo('#section_9 .project-content-title, #section_9 .project-content-title-2, #section_9 .project-content-paragraph, #section_9 .project-content-list', {
        y: 50, 
        opacity: 0,
    } , 
    {
        y: 0, 
        opacity: 1,
        stagger: 0.1,
        duration: 1,
        scrollTrigger: {
            trigger: '#section_8',
            start: 'top-=50 top+=50',
            end: 'center center',
            //markers: true,
        }
    });
    gsap.config({ nullTargetWarn: false });
    gsap.registerPlugin(ScrollTrigger);
    gsap.fromTo('#section_1 .project-content-title, #section_1 .project-content-title-2, #section_1 .project-content-paragraph, #section_1 .project-content-list', {
        y: 50, 
        opacity: 0,
    } , 
    {
        y: 0, 
        opacity: 1,
        stagger: 0.1,
        duration: 1,
        scrollTrigger: {
            trigger: '#abbott-social-listening, #abbott-web-ar, #affin-hwang, #clarins, #ellgy-plus-cny, #adqlo, #mah-sing, #rakuten-trade, #pizzahut-th, #moh, #loreal-groupe, #bake-with-yen-tiktok, #bake-with-yen-social-media, #summer-fun, #shiseido-waso, #nars',
            start: 'top-=150 top+=150',
            end: 'center center',
            // markers: true,
        }
    });
    gsap.fromTo('#section_2 .project-content-title, #section_2 .project-content-title-2, #section_2 .project-content-paragraph, #section_2 .project-content-list', {
        y: 50, 
        opacity: 0,
    } , 
    {
        y: 0, 
        opacity: 1,
        stagger: 0.1,
        duration: 1,
        scrollTrigger: {
            trigger: '#section_1',
            start: 'top-=50 top+=50',
            end: 'center center',
            // markers: true,
        }
    });
    gsap.fromTo('#section_3 .project-content-title, #section_3 .project-content-title-2, #section_3 .project-content-paragraph, #section_3 .project-content-list, #section_3 .bwy-campaign-text', {
        y: 50, 
        opacity: 0,
    } , 
    {
        y: 0, 
        opacity: 1,
        stagger: 0.1,
        duration: 1,
        scrollTrigger: {
            trigger: '#section_2',
            start: 'top-=250 top+=250',
            end: 'center center',
            // markers: true,
        }
    });
    gsap.fromTo('#section_4 .project-content-title, #section_4 .project-content-title-2, #section_4 .project-content-paragraph, #section_4 .project-content-list', {
        y: 50, 
        opacity: 0,
    } , 
    {
        y: 0, 
        opacity: 1,
        stagger: 0.1,
        duration: 1,
        scrollTrigger: {
            trigger: '#section_3',
            start: 'top-=50 top+=50',
            end: 'center center',
            // markers: true,
        }
    });
    gsap.fromTo('#section_5 .project-content-title, #section_5 .project-content-title-2, #section_5 .project-content-paragraph, #section_5 .project-content-list', {
        y: 50, 
        opacity: 0,
    } , 
    {
        y: 0, 
        opacity: 1,
        stagger: 0.1,
        duration: 1,
        scrollTrigger: {
            trigger: '#section_4',
            start: 'top-=50 top+=50',
            end: 'center center',
            // markers: true,
        }
    });
    gsap.fromTo('#section_6 .project-content-title, #section_6 .project-content-title-2, #section_6 .project-content-paragraph, #section_6 .project-content-list, #section_6 .bwy-campaign-text', {
        y: 50, 
        opacity: 0,
    } , 
    {
        y: 0, 
        opacity: 1,
        stagger: 0.1,
        duration: 1,
        scrollTrigger: {
            trigger: '#section_5',
            start: 'top-=50 top+=50',
            end: 'center center',
            // markers: true,
        }
    });
    gsap.fromTo('#section_7 .project-content-title, #section_7 .project-content-title-2, #section_7 .project-content-paragraph, #section_7 .project-content-list', {
        y: 50, 
        opacity: 0,
    } , 
    {
        y: 0, 
        opacity: 1,
        stagger: 0.1,
        duration: 1,
        scrollTrigger: {
            trigger: '#section_6',
            start: 'top-=50 top+=50',
            end: 'center center',
            // markers: true,
        }
    });
    gsap.fromTo('#section_8 .project-content-title, #section_8 .project-content-title-2, #section_8 .project-content-paragraph, #section_8 .project-content-list', {
        y: 50, 
        opacity: 0,
    } , 
    {
        y: 0, 
        opacity: 1,
        stagger: 0.1,
        duration: 1,
        scrollTrigger: {
            trigger: '#section_7',
            start: 'top-=50 top+=50',
            end: 'center center',
            // markers: true,
        }
    });
    gsap.fromTo('#section_9 .project-content-title, #section_9 .project-content-title-2, #section_9 .project-content-paragraph, #section_9 .project-content-list', {
        y: 50, 
        opacity: 0,
    } , 
    {
        y: 0, 
        opacity: 1,
        stagger: 0.1,
        duration: 1,
        scrollTrigger: {
            trigger: '#section_8',
            start: 'top-=50 top+=50',
            end: 'center center',
            // markers: true,
        }
    });
});	